module.exports = class MobileVideoWidget {
  constructor($host, config) {
    this.dom = {
      video: $('video', $host),
      inner: $('.vertical-center', $host),
      button: $('button', $host)
    };

    this.video = this.dom.video[0];

    this.dom.button.on('click', this.play.bind(this));
    this.dom.inner.on('click', this.stop.bind(this));

    this.video.addEventListener('ended', this.stop.bind(this));
  }

  play(event) {
    this.dom.button.hide();
    this.video.currentTime = 0;
    this.video.play();
    event.stopPropagation();
  }

  stop() {
    this.dom.button.show();
    this.video.pause();
  }
};
